import { Link } from "react-router-dom";
import { MapPin, Phone, Facebook } from "lucide-react";

export const Footer = ({ restaurants = [] }) => (
  <footer data-testid="site-footer" className="grain relative border-t border-stone-800 bg-[#0D0C0B] text-stone-400">
    <div className="mx-auto max-w-7xl px-5 pb-28 pt-16 sm:px-8 lg:pb-16">
      <div className="grid gap-12 md:grid-cols-3">
        <div>
          <p className="font-display text-2xl font-bold text-[#FAF6F0]">Nea Mitică</p>
          <p className="font-hand mt-3 text-xl text-red-400">
            „Două case, o singură poftă de viață."
          </p>
          <p className="mt-4 text-sm leading-relaxed">
            Mâncare cinstită, voie bună și beretă roșie. Din 1987, cu aceeași rețetă.
          </p>
        </div>
        {restaurants.map((r) => (
          <div key={r.id}>
            <Link to={`/${r.id}`} data-testid={`footer-link-${r.id}`} className="font-display text-lg font-semibold text-[#FAF6F0] transition-colors hover:text-red-400">
              {r.name}
            </Link>
            <div className="mt-4 space-y-3 text-sm">
              <p className="flex items-start gap-2">
                <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-red-500" />
                {r.address}
              </p>
              <a href={r.phone_link} data-testid={`footer-phone-${r.id}`} className="flex items-center gap-2 transition-colors hover:text-red-400">
                <Phone className="h-4 w-4 text-red-500" />
                {r.phone}
              </a>
              <a
                href={r.social_url || r.gmaps_url}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`footer-social-${r.id}`}
                className="flex items-center gap-2 transition-colors hover:text-red-400"
              >
                <Facebook className="h-4 w-4 text-red-500" />
                Urmărește-ne
              </a>
            </div>
          </div>
        ))}
      </div>
      <div className="mt-14 flex flex-col items-center justify-between gap-3 border-t border-stone-800 pt-6 text-xs sm:flex-row">
        <p>© {new Date().getFullYear()} Nea Mitică. Toate drepturile și toate sarmalele rezervate.</p>
        <p className="font-hand text-base text-stone-500">Cu drag și beretă roșie — Nea Mitică</p>
      </div>
    </div>
  </footer>
);
